import React, { useState } from 'react';
import {
  Box,
  Grid,
  TextField,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
} from '@mui/material'; 
import 'dayjs/locale/ko';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'


import { useEffect } from 'react';

const TaxBillIssuedForm = ({ formik, activeStep, taxbill }) => {
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (taxbill) {
      if (taxbill.invTyp === '매출') {
        setMessage("재고가 출고 되었습니다.(매출 세금계산서)")
      } else {
        setMessage("재고로 입고되었습니다.(매입 세금계산서)")
      }
    }
  }, [taxbill])


  return (
    <>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 1,
          px: 2,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                <DatePicker
                  label="발행예정일"
                  format="YYYY-MM-DD"
                  mask={'____-__-__'}
                  disabled={activeStep !== 0}
                  id="reqPlanDt"
                  name="reqPlanDt"
                  value={dayjs(formik.values.reqPlanDt) || ''}
                  onChange={(newValue) => {
                    formik.setFieldValue('reqPlanDt', dayjs(newValue));
                  }}
                  slotProps={{
                    textField: {
                      margin: "normal",
                      variant: "outlined",
                      error:
                        formik.touched.reqPlanDt &&
                        Boolean(formik.errors.reqPlanDt),
                      helperText: formik.touched.reqPlanDt && formik.errors.reqPlanDt,
                      fullWidth: true,
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6}>
              <TextField
                margin="normal"
                required
                variant="outlined"
                fullWidth
                disabled={activeStep !== 0}
                id="reqPlanTxt"
                name="reqPlanTxt"
                label="발행요청 비고"
                value={formik.values.reqPlanTxt}
                onChange={formik.handleChange}
                error={
                  formik.touched.reqPlanTxt && Boolean(formik.errors.reqPlanTxt)
                }
                helperText={
                  formik.touched.reqPlanTxt && formik.errors.reqPlanTxt
                }
              />
            </Grid>
            <Grid item xs={3}>
              <FormGroup>
                <FormControlLabel
                  id="reqPlanYn"
                  name="reqPlanYn"
                  label="발행요청"
                  disabled={activeStep !== 0}
                  control={
                    <Checkbox
                      checked={formik.values.reqPlanYn}
                      onChange={formik.handleChange}
                    />
                  }
                />
              </FormGroup>
            </Grid>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={1}
          >
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
                <DatePicker
                  label="발행일"
                  format="YYYY-MM-DD"
                  mask={'____-__-__'}
                  disabled={activeStep !== 1}
                  id="reqCompDt"
                  name="reqCompDt"
                  value={dayjs(formik.values.reqCompDt) || ''}
                  onChange={(newValue) => {
                    formik.setFieldValue('reqCompDt', dayjs(newValue));
                  }}
                  slotProps={{
                    textField: {
                      margin: "normal",
                      variant: "outlined",
                      disabled: activeStep !== 1,
                      error:
                        formik.touched.reqCompDt &&
                        Boolean(formik.errors.reqCompDt),
                      helperText: formik.touched.reqCompDt && formik.errors.reqCompDt,
                      fullWidth: true,
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={6}>
              <TextField
                margin="normal"
                required
                variant="outlined"
                fullWidth
                disabled={activeStep !== 1}
                id="reqCompTxt"
                name="reqCompTxt"
                label="발행완료 비고"
                value={formik.values.reqCompTxt}
                onChange={formik.handleChange}
                error={
                  formik.touched.reqCompTxt && Boolean(formik.errors.reqCompTxt)
                }
                helperText={
                  formik.touched.reqCompTxt && formik.errors.reqCompTxt
                }
              />
            </Grid>
            <Grid item xs={3}>
              <FormGroup>
                <FormControlLabel
                  id="reqCompYn"
                  name="reqCompYn"
                  label="발행완료여부"
                  disabled={activeStep !== 1}
                  control={
                    <Checkbox
                      checked={formik.values.reqCompYn}
                      onChange={formik.handleChange}
                    />
                  }
                />
              </FormGroup>
            </Grid>
          </Grid>
        </Grid>
        {taxbill?.reqCompYn === 'Y' && (
          <Box sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            m: 1,
          }}>
            <Typography variant="subtitle2" component="div" color="error">{message}</Typography>
          </Box>
        )}
        {activeStep <= 1 && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              my: 2,
            }}

          >
            <Button
              type="submit"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              저장
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
};

export default TaxBillIssuedForm;
